export default "__VITE_ASSET__d5f119af__"